import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const WelcomeSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-background pt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-5">
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative">

            <div className="relative rounded-2xl overflow-hidden shadow-warm-xl">
              <Image
                src="/assets/images/468318950_17926839803985883_3727174145635237492_n-1767724048808.jpg"
                alt="Delicious food spread featuring empanadas, rice, nachos, cocktails and Kahlovera menu on wooden table"
                className="w-full h-[400px] object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center sm:text-left">

            <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
              <Icon name="Heart" size={20} className="text-accent" />
              <span className="text-accent font-body font-medium">WELCOME</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
              Welcome to <span className="text-primary">Kahlovera</span>
            </h2>

            <p className="text-lg text-muted-foreground font-body mb-8 leading-relaxed">
              Bold Mexican food with heart. We bring authentic flavors and modern energy to Chapel Hill, creating a space where great food brings people together.
            </p>

            <Button
              onClick={() => navigate('/reservations')}
              className="bg-accent text-accent-foreground hover:bg-accent/90 px-8 py-3 text-lg font-semibold rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300">

              Make a Reservation
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );


};

export default WelcomeSection;